import Locations from './locations';
import OpeningHours from './opening-hours';

export default {
  Locations,
  OpeningHours,
};
